<app-header [disableMenu]="disableMenu">
</app-header>
<div>
  <router-outlet (activate)="onOutletLoaded($event)"></router-outlet>
</div>
<app-footer></app-footer>